import '../utils/comparison-table.css';
import { Link, NavLink } from 'react-router-dom';

// ComparisonTable.jsx
export default function ComparisonTable() {
  return (
    <div className="container my-5">
      <div className="row">

        {/* Text Column - (no change here) */}
        <div className="col-lg-6 d-flex justify-content-center align-items-center order-lg-3">
          <div className="mb-4 mt-4 mt-lg-0 mt-lg-0 ms-lg-4 text-left">
            <h4 className='f-uc'>Farewell to unfair terms</h4>
            <p>Hourly fees, agency fees, royalty fees, intimacy fees, extra licensing fees, their list goes on. Our doesn't.</p>
            <Link
              to="/contact"
              className="btn btn-link py-2 px-3 mb-3 b-c0 o-c00 c-c00"
            >
              Let's Talk
            </Link>
          </div>
        </div>

        {/* Table Column - Wrap the table in a div with rounded and overflow-hidden */}
        <div className="col-lg-6 order-lg-1">
          <div className="rounded overflow-hidden"> {/* ADDED THIS WRAPPER */}
            <table className="compare-table table table-bordered text-center align-middle mb-0 f-b">
              <thead className="align-middle table-dark">{/*
    */}<tr>{/*
      */}<th className="f-uc f-a">Feature</th>{/*
      */}<th className="f-uc f-a">Model<br />Agencies</th>{/*
      */}<th className="f-uc f-a"><b>ITORA</b></th>{/*
    */}</tr>{/*
  */}</thead>
              <tbody>{/*
    */}<tr>{/*
      */}<td>Model Fee</td>{/*
      */}<td>Hourly</td>{/*
      */}<td>Flat</td>{/*
    */}</tr>{/*
    */}<tr>{/*
      */}<td>Agency Markup</td>{/*
      */}<td>✓</td>{/*
      */}<td>X</td>{/*
    */}</tr>{/*
    */}<tr>{/*
      */}<td>Hidden Fees</td>{/*
      */}<td>✓</td>{/*
      */}<td>X</td>{/*
    */}</tr>{/*
    */}<tr>{/*
      */}<td>Usage Rights</td>{/*
      */}<td>Limited</td>{/*
      */}<td>Unlimited</td>{/*
    */}</tr>{/*
    */}<tr>{/*
      */}<td>Content License</td>{/*
      */}<td>Expires</td>{/*
      */}<td>Unlimited</td>{/*
    */}</tr>{/*
    */}<tr>{/*
      */}<td>Exclusivity</td>{/*
      */}<td>None</td>{/*
      */}<td>Available</td>{/*
    */}</tr>{/*
    */}<tr>{/*
      */}<td>Hair & Makeup</td>{/*
      */}<td>Required</td>{/*
      */}<td>Not Required</td>{/*
    */}</tr>{/*
  */}</tbody>
            </table>
          </div> {/* END OF WRAPPER */}
        </div>


      </div>
    </div>
  );
}